import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  //CardActions,
  //Button,
  Divider,
  List,
  ListItem,
  //ListItemAvatar,
  //ListItemText,
  //IconButton,
  Typography, 
} from '@material-ui/core';
//import ArrowRightIcon from '@material-ui/icons/ArrowRight';
//import MoreVertIcon from '@material-ui/icons/MoreVert';

//import mockData from './data';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  content: {
    padding: 0
  },
  actions: {
    justifyContent: 'flex-end'
  },
  listItemNumber: {
    width: '40px',
  },
  listItemName: {
    width: '160px',
  },
  listItemCount: {
    width: '80px',
  },
  card_header: {
    backgroundColor: theme.palette.card_header,
  }
}));

const AdvertiseInfos = props => {
  const { className, infos, ...rest } = props;

  const classes = useStyles();

  //const [infos] = useState(mockData);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        className={classes.card_header}
        // subtitle={`${products.length} in total`}
        title="광고누적횟수"
      />
      <Divider />
      <CardContent className={classes.content}>
        <List>
          {infos.map((info, index) => (
            <ListItem
              divider={index < info.length - 1}
              key={'adinfo-'+index}
            >
            <Typography
              className={classes.listItemNumber}
              //color="textSecondary"
              //gutterBottom
            >
              {index+1}
            </Typography>
            <Typography
              className={classes.listItemName}
              //color="textSecondary"
              //gutterBottom
            >
              {info.name}
            </Typography>
            <Typography
              className={classes.listItemCount}
              align='right'
              //color="textSecondary"
              //gutterBottom
            >
              {info.count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}회
            </Typography>

              {/* <ListItemText
                primary={i + "  " + info.name + "  " + info.count}
                // secondary={`Updated ${product.updatedAt.fromNow()}`}
              /> */}
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

AdvertiseInfos.propTypes = {
  className: PropTypes.string,
  infos: PropTypes.array.isRequired,
};

AdvertiseInfos.defaultProps = {
  infos: [],
};

export default AdvertiseInfos;
